import { PartnerType, SubBrokerType } from '../../shared/generated';
import { getLocalTranslation } from '../i18nKit';
export var getBrokerCommissionTitleText = function getBrokerCommissionTitleText(config) {
  var isPartner = (config === null || config === void 0 ? void 0 : config.partnerType) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.source) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.subBrokerType) === SubBrokerType.PARTNER;
  return isPartner ? 'Partner referral fee' : !!(config !== null && config !== void 0 && config.subBrokerType) ? 'Sub-broker commission' : 'Broker commission';
};
export var getBrokerFeeTitleText = function getBrokerFeeTitleText(config) {
  var isPartner = (config === null || config === void 0 ? void 0 : config.partnerType) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.source) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.subBrokerType) === SubBrokerType.PARTNER;
  return isPartner ? 'Partner fee' : !!(config !== null && config !== void 0 && config.subBrokerType) ? 'Sub-broker fee' : 'Broker fee';
};
export var getUnderwritingFeeTitleText = function getUnderwritingFeeTitleText(config) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return $t('kit:brokers.underwriting_fee_from_jove');
};
export var getUnderwritingFeeCapTitleText = function getUnderwritingFeeCapTitleText(config) {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return $t('kit:brokers.underwriting_fee_cap');
};
export var getBrokerNameTitleText = function getBrokerNameTitleText(config) {
  var isPartner = (config === null || config === void 0 ? void 0 : config.partnerType) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.source) === PartnerType.GENERAL || (config === null || config === void 0 ? void 0 : config.subBrokerType) === SubBrokerType.PARTNER;
  return isPartner ? 'Partner name' : 'Broker name';
};